$(function () {

    // Initialize datepicker for all inputs
    $(".datepicker").datepicker({
        dateFormat: "dd-mm-yy",
        changeMonth: true,
        changeYear: true
    });

    // Open datepicker for corresponding input
    $(".openCalendar").on("click", function () {
        $(this).prev(".datepicker").focus();
    });

});


/*
$(function () {
    $("#invitationDate").datepicker({
        dateFormat: "dd-mm-yy",
        changeMonth: true,
        changeYear: true
    });

    $("#openCalendar").click(function () {
        $("#invitationDate").focus();
    });
});*/

